import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

type Props = {
  onlyEnabled: string;
};

function useGetAllProblemStatus({ onlyEnabled }: Props) {
  const { t } = useTranslation('global');
  const { showApiError } = useGlobalContext();
  const { processApi } = useApiContext();

  return useQuery(
    [KEYS.process.problemStatus.getAllProblemStatus()],
    () => processApi.ProblemStatus.getAllProblemStatus(onlyEnabled),
    {
      refetchOnWindowFocus: false,
      select: ({ data }) =>
        data.data.map((status) => ({
          name: status.name,
          id: status.id,
          enabled: status.enabled,
          base: status.base
        })),
      onError: (error) =>
        showApiError(error, t('common.commonMessages.genericRequestError'))
    }
  );
}

export default useGetAllProblemStatus;
